import React, { Component } from 'react';
import moment from 'moment';
import { QueryService } from 'services/queries';
import ErrorType from 'services/ErrorType';
import config from 'services/config';
import MoneyValue from 'components/MoneyValue';

import {SingleDatePicker} from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import Select from 'react-select'
import 'react-select/dist/react-select.css';

let _humanize = s => {
  return s ? s.replace(/_/g, ' ').trim().replace(/([^\s])([A-Z])/g, '$1 $2').replace(/\b[A-Z][a-z]+\b/g, function (x) {
    return x.toLowerCase();
  }).replace(/^[a-z]/g, function (x) {
    return x.toUpperCase();
  }) : null;
};

class BalanceBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="card">
        <h3 className="card-title">
          {_humanize(this.props.display_name)}
          <div className="pull-right"><MoneyValue value={this.props.balance}/></div>
        </h3>
          <table className="table table-condensed">
            <thead>
              <tr>
                <th className="col-md-6 text-left">Type</th>
                <th className="col-md-6 text-right">Balance</th>
              </tr>
            </thead>
            <tbody>
              {this.props.subtotals.map(subtotal => ( subtotal.balance != 0 &&
                <tr>
                  <td className="text-left">{
                    (this.props.journal == 'buyer_receivables')
                      ? subtotal.balance_type.replace(/_/g, ' ').replace(/TopHatter/, 'Tophatter')
                      : subtotal.balance_type_display
                  }</td>
                  <td className="text-right"><MoneyValue value={subtotal.balance} currency={subtotal.currency}/></td>
                </tr>
              ))}
            </tbody>
          </table>
      </div>
    );
  }
}


class Balances extends Component {
  constructor(props) {
    super(props);
    this.state = {
      balanceDate: this.props.maxDate,
      balanceDateFocus: false,
      balances: [],
      currentPage: 1,
      pageSize: 100,
      recordCount: 0,
      currency: 'usd'
    };
    this.onBalanceDateChange = this.onBalanceDateChange.bind(this);
    this.onBalanceDateFocusChange = this.onBalanceDateFocusChange.bind(this);
    this.isOutsideBalanceDateRange = this.isOutsideBalanceDateRange.bind(this);
    this.onCurrencyChange = this.onCurrencyChange.bind(this);
    this.queryService = new QueryService(this.props.book)
  }

  async componentWillMount() {
    let newBalances = await this._fetchBalances(this.state.currency, this.state.balanceDate);
    this.setState({...newBalances});
  }

  onBalanceDateFocusChange(p) {
    this.setState({
      balanceDateFocus: p.focused
    });
  }

  async onBalanceDateChange(date) {
    let newBalances = await this._fetchBalances(this.state.currency, date);
    this.setState({...newBalances});
  }

  async _fetchBalances(currency, date) {
    try {
      console.log('fetching: ', currency)
      let result = (currency == 'local')
                    ? await this.queryService.getBalanceSummaryLocal(date)
                    : await this.queryService.getBalanceSummary(date)
      console.log(result)
      return {
        balances: result,
        balanceDate: date,
        currency: currency
      }
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  isOutsideBalanceDateRange(date) {
    return moment().add(1, 'days').isBefore(date)
  }


  async onCurrencyChange(currency) {
    let newBalances = await this._fetchBalances(currency.value, this.state.balanceDate);
    this.setState({...newBalances});
  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-hourglass-2"></i> Trial balance</h1>
            <p>Balances for each subledger</p>
          </div>
          <div className="form-inline">
            <label className="header-input">
              <span className="period">Currency</span>
              <Select
                className="form-control" 
                name="Currency"
                options={[
                  { value: 'usd', label: 'USD' },
                  { value: 'local', label: 'Local' }
                ]}
                value={this.state.currency}
                clearable={false}
                searchable={false}
                onChange={this.onCurrencyChange}
              />
            </label>
            <label className="header-input">
              <span className="period">Date</span>
              <SingleDatePicker
                date={this.state.balanceDate}
                onDateChange={this.onBalanceDateChange}
                onFocusChange={this.onBalanceDateFocusChange}
                focused={this.state.balanceDateFocus}
                numberOfMonths={1}
                isOutsideRange={this.isOutsideBalanceDateRange} />
            </label>

            {/*<ul className="breadcrumb">
              <li><i className="fa fa-home fa-lg"></i></li>
              <li>Tables</li>
              <li className="active"><a href="#">Simple Tables</a></li>
            </ul>*/}
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              {this.state.balances.filter( item => item.ledger_side == 'left' ).map(item => (
                <BalanceBox {...item} />
              ))}
          </div>
          <div className="col-md-6">
              {this.state.balances.filter( item => item.ledger_side == 'right' ).map(item => (
                <BalanceBox {...item} />
              ))}
          </div>
        </div>
      </div>
    )
  }
}

export default Balances;

/*

          <div className="row">
            <div className="form-inline">
              <div className="col-sm-6">
                <label className="balance-date">
                  <span className="period">Date</span>
                  <SingleDatePicker
                    date={this.state.balanceDate}
                    onDateChange={this.onBalanceDateChange}
                    onFocusChange={this.onBalanceDateFocusChange}
                    focused={this.state.balanceDateFocus}
                    numberOfMonths={1}
                    isOutsideRange={this.isOutsideBalanceDateRange} />
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <BalanceSummary
                data={this.state.balances}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-offset-10 col-lg-2">
              <a href="#download" onClick={this.downloadCsv} className="pull-right">Download CSV</a>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <SellerBalanceBySeller data={this.state.sellerDetailBalances}
                   currentPage={this.state.currentPage}
                   pageSize={this.state.pageSize}
                   recordCount={this.state.recordCount}
                   onPaginationChanged={this.onPaginationChanged}/>
            </div>
          </div>
      </div>
*/


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Balances/index.js